import Index from "../container/Admin/Admin.js";
import getComponent from "../components/common/GetComponent";

const Register = props =>
  getComponent(props, () => import("../container/register.jsx"));

const Login = props =>
  getComponent(props, () => import("../container/login.jsx"));

const ManageNews = props =>
  getComponent(props, () => import("../container/News/Manage.jsx"));

const AddNew = props =>
  getComponent(props, () => import("../container/News/AddNew.jsx"));

const EditNew = props =>
  getComponent(props, () => import("../container/News/EditNew.jsx"));

const ManageJobs = props =>
  getComponent(props, () => import("../container/Jobs/Manage.jsx"));

const AddJob = props =>
  getComponent(props, () => import("../container/Jobs/AddJob.jsx"));

const EditJob = props =>
  getComponent(props, () => import("../container/Jobs/EditJob.jsx"));

const CompanyInfo = props =>
  getComponent(props, () => import("../container/companyInfo.jsx"));
  
const AddImg = props =>
  getComponent(props, () => import("../container/addImg.jsx"));  

const ManageMatters = props =>
  getComponent(props, () => import("../container/Matters/Manage.jsx"));

const AddMatter = props =>
  getComponent(props, () => import("../container/Matters/AddMatter.jsx"));

const EditMatter = props =>
  getComponent(props, () => import("../container/Matters/EditMatter.jsx"));
  
const ManageMessage = props =>
  getComponent(props, () => import("../container/Message/Manage.jsx"));

const routes = [
  {
    path: "/atomjaylee",
    component: Register
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/admin",
    component: Index,
    routes: [
      {
        name: "新闻管理",
        path: "/admin/news",
        component: ManageNews
      },
      {
        name: "添加新闻",
        path: "/admin/addNew",
        component: AddNew
      },
      {
        name: "编辑新闻",
        path: "/admin/editNew/:id",
        component: EditNew
      },
      {
        name: "职位管理",
        path: "/admin/jobs",
        component: ManageJobs
      },
      {
        name: "添加职位",
        path: "/admin/addJob",
        component: AddJob
      },
      {
        name: "编辑职位",
        path: "/admin/editJob/:id",
        component: EditJob
      },
      {
        name: "公司信息",
        path: "/admin/companyInfo",
        component: CompanyInfo
      },
      {
        name: "图片管理",
        path: "/admin/addImg",
        component: AddImg
      },
      {
        name: "事项管理",
        path: "/admin/matters",
        component: ManageMatters
      },
      {
        name: "添加事项",
        path: "/admin/addMatter",
        component: AddMatter
      },
      {
        name: "编辑事项",
        path: "/admin/editMatter/:id",
        component: EditMatter
      },
      {
        name: "留言信息",
        path: "/admin/messages",
        component: ManageMessage
      },
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/Config.js